/**
 * Conference Room Time Utilities
 * Handles time calculations and formatting for conference room displays
 */

const MINUTES_IN_HOUR = 60;
const SOON_OCCUPIED_THRESHOLD_MINUTES = 30;

/**
 * Formats current time as HH:MM:SS
 * @returns {string} Formatted time string
 */
export function getCurrentTimeString() {
    const today = new Date();
    const time =
        ("0" + today.getHours()).slice(-2) +
        ":" +
        ("0" + today.getMinutes()).slice(-2) +
        ":" +
        ("0" + today.getSeconds()).slice(-2);
    return time.substr(0, 10);
}

/**
 * Gets current hour from timestamp
 * @param {string} timestamp - Time string in HH:MM:SS format
 * @returns {number} Hour as integer
 */
export function getHourFromTimestamp(timestamp) {
    return parseInt(timestamp.substr(0, 2));
}

/**
 * Calculates booking end time (30 minutes from now)
 * @param {object|null} nextBooking - Next booking object
 * @param {string} occupationStatus - Current occupation status
 * @returns {string} ISO datetime string for booking end
 */
export function calculateBookingEndTime(nextBooking, occupationStatus) {
    const today = new Date().toISOString().substring(0, 10);
    const date = new Date();
    date.setMinutes(date.getMinutes() + SOON_OCCUPIED_THRESHOLD_MINUTES);

    if (nextBooking && occupationStatus === "soonOccupied") {
        return nextBooking.start;
    }

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

    return `${today} ${hours}:${formattedMinutes}:00`;
}

/**
 * Extracts time portion from datetime string (HH:MM)
 * @param {string} datetime - Datetime string
 * @returns {string} Time in HH:MM format
 */
export function extractTime(datetime) {
    return datetime.slice(11, 16);
}

/**
 * Extracts full time portion from datetime string (HH:MM:SS)
 * @param {string} datetime - Datetime string
 * @returns {string} Time in HH:MM:SS format
 */
export function extractFullTime(datetime) {
    return datetime.slice(11);
}

/**
 * Gets current date in ISO format (YYYY-MM-DD)
 * @returns {string} Current date
 */
export function getCurrentDate() {
    return new Date().toISOString().substring(0, 10);
}
